import {Injectable} from '@angular/core';
import 'rxjs/Rx';
@Injectable()
export class CartServiceProvider {
    Cart: any[] = [];
    itemCart: any = {};
    itemInCart = [];

    constructor() {
        this.Cart = JSON.parse(localStorage.getItem('Cart'));
    }

    OnsaveLS(item: any) {
        this.Cart = JSON.parse(localStorage.getItem('Cart'));
        let ExtotalPrice : number = 0;
        let totalPrice :number = 0;
        this.itemInCart = [];
        if (this.Cart == null) {
            for (let i = 0; i <= item.extraOptions.length - 1; i++) {
                ExtotalPrice = Number(ExtotalPrice) + Number(item.extraOptions[i].value);
            }
            ExtotalPrice = Number(this.roundTo(ExtotalPrice,2));
                if(item.price.specialPrice){
                    totalPrice = this.roundTo(item.price.specialPrice, 2);
                } else {
                totalPrice =item.price.value;
                }
            
            this.itemCart.itemTotalPrice = Number(this.roundTo((totalPrice * item.itemQunatity),2));
            this.itemCart.item = item;
            this.itemCart.ExtraOptionTotal = Number(this.roundTo((ExtotalPrice * item.itemQunatity),2));
            this.itemInCart.push(this.itemCart);
            localStorage.setItem('Cart', JSON.stringify(this.itemInCart));
        }
        else {
            for (let i = 0; i <= this.Cart.length - 1; i++) {
                if (this.Cart[i].item.itemId == item.itemId && this.Cart[i].item.price.pname == item.price.pname) {
                    // this.Cart.splice(i, 1);
                }
            }
            for (let k = 0; k <= item.extraOptions.length - 1; k++) {
                ExtotalPrice = Number(ExtotalPrice) + Number(item.extraOptions[k].value);
            }
            ExtotalPrice = Number(this.roundTo(ExtotalPrice,2));
            if(item.price.specialPrice){
                    totalPrice =this.roundTo(item.price.specialPrice,2);
                } else {
                totalPrice =item.price.value;
                }
            this.itemCart.itemTotalPrice = Number(this.roundTo((totalPrice * item.itemQunatity),2));
            this.itemCart.item = item;
            this.itemCart.ExtraOptionTotal = Number(this.roundTo((ExtotalPrice * item.itemQunatity),2));
            this.Cart.push(this.itemCart);
            localStorage.setItem('Cart', JSON.stringify(this.Cart));
        }
    }
    roundTo(n, digits) {
        var negative = false;
        if (digits === undefined) {
            digits = 0;
        }
            if( n < 0) {
            negative = true;
          n = n * -1;
        }
        var multiplicator = Math.pow(10, digits);
        n = parseFloat((n * multiplicator).toFixed(11));
        n = (Math.round(n) / multiplicator).toFixed(2);
        if( negative ) {    
            n = (n * -1).toFixed(2);
        }
        return n;
      }
}


// WEBPACK FOOTER //
// ./src/providers/cart-service/cart-service.ts